import React from 'react'
import PropTypes from 'prop-types'
import { compose, withContext, getContext } from 'recompose'

export const withAssets = () => compose(
  withContext(
    { assets: PropTypes.object },
    ({ assets }) => ({ assets: assets || {} })
  )
)

export const getAssets = () => compose(
  getContext({ assets: PropTypes.object })
)



// WEBPACK FOOTER //
// ./src/components/Canvas/renderer/utils/withAssets.js